import { Fragment } from "react";
import React from "react";
import { Transition } from "@headlessui/react";
import { Navigate } from "react-router-dom";
import {
  XIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
} from "@heroicons/react/solid";
import axios from "axios";


class ExpenseCreatemodal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      success: false,
      redirect: false,
      expense_category_id: "",
      mode_of_payment_id: "",
      date: "",
      note: "",
      amount: "",
      request_person:"",
      branch_id:[],
      expensecategoryList: [],
      modeofpaymentList: [],
      branchList:[],
      loader_status: false,
      try_again_status: false,
      main_content_status: false,

      error_list: [],
    };
    this.handleInput = this.handleInput.bind(this);
  }
  setLoaderFunction = () => {

    this.setState({
        loader_status: true,
        try_again_status: false,
        main_content_status: false,
    });
    };
    closeLoaderFuncion = () => {
    this.setState({
        loader_status: false,
        try_again_status: false,
        main_content_status: true,
    });
    };
    
    enableTryAgain = () => {
    
    this.setState({
        loader_status: false,
        try_again_status: true,
        main_content_status: false,
    });
    };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    this.setState({ sidebarOpen: true });
  };

  async componentDidMount() {

    this.getDataForPagination();

  }


  async getDataForPagination() {
    try {
      this.setLoaderFunction()
      const token = localStorage.getItem("token");
      const [

        { data: categories },
        { data: modeofpaymentList },


      ] = await Promise.all([
        axios.get("api/expense/categories", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
        axios.get("api/modeofpayment", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),

      ]);


      this.setState({ expensecategoryList: categories.expense_categories });
      this.setState({ modeofpaymentList: modeofpaymentList.mode_of_payment });

      
      this.closeLoaderFuncion();

    } catch (error) {
      this.enableTryAgain();
    }
  }


  tryAgain = () => {
        this.getDataForPagination();
  }


  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleInputwarehouseF = (e) => {
    this.props.handleInputwarehouseA(e);
  };

  saveItem = async (e) => {
    e.preventDefault();
this.setLoaderFunction();
    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const res = await axios.post("api/expense/store", this.state, {
      headers,
    });

    if (res.data.success) {
      this.setState({ showmsg: true });
      this.handleInputwarehouseF(res.data.success);
      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
      this.closeLoaderFuncion();
    } else {
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
      this.closeLoaderFuncion();
    }
    this.closeLoaderFuncion();
  };

  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    if (res.data.success) {
      localStorage.removeItem("token");
      this.setState({ logoutRedirect: true }); 
    }
  };

  //Logout function

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
<div aria-hidden="true" />
 {/*loader_status------------------------------------------------------------------------*/}
 {this.state.loader_status && (
                    <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                        <div className="bg-white p-4 rounded-md">
                            <div className="flex items-center justify-center">
                                <div
                                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                            </div>
                            <p className="text-center mt-4">Loading...</p>
                        </div>
                    </div>
                )}
                {/*loader_status------------------------------------------------------------------------*/}

                {/*try_again_status-----------------------------------------------------------------------------*/}
                {this.state.try_again_status && (
                    <div className="h-screen flex items-center justify-center bg-white ">
                        <div className="flex flex-col items-center justify-center h-full">
                            <p className="text-red-500">{this.state.error_customize}</p>
                            <button
                                type="button"
                                onClick={this.tryAgain}
                                className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                TryAgain
                            </button>
                        </div>
                    </div>
                )}
                {/*try_again_status-----------------------------------------------------------------------------*/}





                {this.state.main_content_status && (
                  <div className="flex flex-col flex-1">
        <main className="flex-1">
          <div className="py-6">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <h1 className="text-2xl font-semibold text-gray-900">
                New Expenses
              </h1>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              {/* Replace with your content */}

              <div className="hidden sm:block" aria-hidden="true">
                <div className="py-5">
                  <div className="border-t border-gray-200" />
                </div>
              </div>
              <div className={`mt-10 sm:mt-0 ${this.state.loader}`}>
                <div className="md:grid md:gap-6">
                  <div className="mt-5 md:mt-0 md:col-span-2">
                    <form onSubmit={this.saveItem}>
                      <div className="shadow overflow-hidden sm:rounded-md">
                        <div className="px-4 py-5 bg-white sm:p-6">
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="expense_category_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Expense Category
                                </span>
                              </label>
                              <select
                                id="expense_category_id"
                                name="expense_category_id"
                                onChange={this.handleInput}
                                autoComplete="expense_category_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.expensecategoryList.map(
                                  (number,index) => (
                                    <option key={index} value={number.id}>
                                      {number.name}
                                    </option>
                                  )
                                )}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.expense_category_id}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="mode_of_payment_id"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Mode of Payment
                                </span>
                              </label>
                              <select
                                id="mode_of_payment_id"
                                name="mode_of_payment_id"
                                onChange={this.handleInput}
                                autoComplete="mode_of_payment_id"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                              >
                                <option value="">------</option>
                                {this.state.modeofpaymentList.map((number,index) => (
                                  <option key={index} value={number.id}>
                                    {number.name}
                                  </option>
                                ))}
                              </select>
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="email-error"
                              >
                                {this.state.error_list.mode_of_payment_id}
                              </p>
                            </div>
                            

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="date"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Date
                                </span>
                              </label>
                              <input
                                type="date"
                                name="date"
                                onChange={this.handleInput}
                                id="date"
                                autoComplete="address-level2"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="date-error"
                              >
                                {this.state.error_list.date}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="amount"
                                className="block text-sm font-medium text-gray-700"
                              >
                                <span className="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                  Amount
                                </span>
                              </label>
                              <input
                                type="number"
                                name="amount"
                                onChange={this.handleInput}
                                id="amount"
                                autoComplete="amount"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="amount-error"
                              >
                                {this.state.error_list.amount}
                              </p>
                            </div>

                            <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                              <label
                                htmlFor="request_person"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Request Person
                              </label>
                              <input
                                type="text"
                                name="request_person"
                                id="request_person"
                                onChange={this.handleInput}
                                autoComplete="address-level1"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="request_person-error"
                              >
                                {this.state.error_list.request_person}
                              </p>
                            </div>


                            <div className="col-span-6 sm:col-span-3 lg:col-span-6">
                              <label
                                htmlFor="note"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Note
                              </label>
                              <textarea
                                type="text"
                                name="note"
                                id="note"
                                onChange={this.handleInput}
                                autoComplete="address-level1"
                                className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                              />
                              <p
                                className="mt-2 text-sm text-red-600"
                                id="note-error"
                              >
                                {this.state.error_list.note}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                          <button
                            type="submit"
                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* /End replace */}
            </div>
          </div>
        </main>
        </div>
                )}

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default ExpenseCreatemodal;
